import { useAtomValue } from "jotai";
import { userAtom } from "../../../utils/store";
import PageLayout from "../../../layouts/pageLayout/pageLayout";

const ApplicationStatus = () => {
  const user = useAtomValue(userAtom);
  const fullName = `${user?.firstName || ""} ${user?.lastName || ""}`.trim();
  return (
    <div>
      <PageLayout heading="Application Status">
        <p>Hello, {fullName}</p>
        <p>Program: {user?.programName}</p>
      </PageLayout>
    </div>
  );
};

export default ApplicationStatus;
